var React = require('react');

function AlertTriangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)"},[React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"M6.69.737L.206 11.57a1.533 1.533 0 0 0 1.31 2.298h12.97a1.531 1.531 0 0 0 1.31-2.298L9.309.737a1.531 1.531 0 0 0-2.618 0zM8 5v3","key":0}),React.createElement("circle",{"cx":"7.853","cy":"10.853","r":"1","fill":"currentColor","key":1})]));
}

AlertTriangle.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18"};

module.exports = AlertTriangle;

AlertTriangle.default = AlertTriangle;
